import React from "react";

export type TemplateData = Record<string, React.ReactNode>;

/**
 * Renders a string template with placeholders (e.g. "{{price}}") by replacing them
 * with corresponding values or React components from the data object.
 *
 * Example:
 *  renderTemplate("{{price}} {{currency}} per passenger", {
 *    price: 2500,
 *    currency: "PHP"
 *  })
 *
 *  // -> renders "2500 PHP per passenger"
 *
 * Supports React components:
 *  renderTemplate("Book now: {{button}}", {
 *    button: <button>Click</button>
 *  })
 */
export function renderTemplate(template: string, data: TemplateData): React.ReactNode {
  const parts = template.split(/({{\s*\w+\s*}})/g);

  const nodes = parts.map((part, index): React.ReactNode => {
    const match = part.match(/{{\s*(\w+)\s*}}/);
    if (match) {
      const key = match[1];
      // ensure key is a string before indexing `data` to satisfy TS
      const value = typeof key === "string" ? (data[key] ?? "") : "";
      return <React.Fragment key={`placeholder-${key}-${index}`}>{value}</React.Fragment>;
    }
    return part;
  });

  return nodes;
}
